import FilterPage from './[section]'

FilterPage.lazyLoadSentry = false

export default FilterPage
